import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function Forbidden() {
  return (
    <div className="bg-white min-h-[70vh] flex flex-col items-center justify-center px-6 py-12 text-center">
      <SEO title="403 Adgang Nægtet - Dansketelemaster Invest" description="Du har ikke adgang til denne side." />
      
      <div className="max-w-md space-y-6">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-red-50 text-red-500 mb-2">
          <i className="fa-solid fa-ban text-4xl" />
        </div>
        
        <h1 className="text-4xl font-extrabold text-slate-900 tracking-tight">
          403 - Adgang Nægtet
        </h1>
        
        <p className="text-slate-600 leading-relaxed">
          Beklager, men du har ikke de nødvendige rettigheder til at se denne side. Hvis du mener, at dette er en fejl, bedes du kontakte os.
        </p>
        
        <div className="pt-4">
          <Link
            to="/"
            className="bg-[#2a4692] hover:bg-[#1d3166] text-white font-bold px-6 py-3 rounded-md transition-all inline-flex items-center gap-2 cursor-pointer"
          >
            <i className="fa-solid fa-house text-sm" />
            Gå til forsiden
          </Link>
        </div>
      </div>
    </div>
  );
}
